import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { CONSENT_GATE_PATH, consentGateHref } from '@/entities/terms';
import { CONSENT_REQUIRED_EVENT } from '@/shared/api/consent-required';

/**
 * G7 — 공통 응답 처리가 403 TERMS_007 을 받으면 쏘는 이벤트를 받아 동의 화면으로 보낸다(지금 있던 주소를 `from` 으로).
 * 라우터 안(모든 라우트의 공통 조상 RootLayout)에 한 번만 둔다. 이미 동의 화면이면 아무것도 안 한다(여러 요청이 동시에 403 일 때 중복 이동 방지).
 */
const ConsentRequiredRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onRequired = () => {
      if (location.pathname === CONSENT_GATE_PATH) return;
      navigate(consentGateHref(location.pathname + location.search));
    };
    window.addEventListener(CONSENT_REQUIRED_EVENT, onRequired);
    return () => window.removeEventListener(CONSENT_REQUIRED_EVENT, onRequired);
  }, [navigate, location.pathname, location.search]);

  return null;
};

export default ConsentRequiredRedirect;
